import validate from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@4.2.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.24_eslint@9.39.1_oxlint@1.26.0_oxl_9e05633248f8aea984820b28623ab0ac/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@4.2.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.24_eslint@9.39.1_oxlint@1.26.0_oxl_9e05633248f8aea984820b28623ab0ac/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-to-landing-page": () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/middleware/redirect-to-landing-page.ts")
}